// base
import React from 'react';

// variables
import { alertIcons } from 'variables';

// libraries
import { notification } from 'antd';

const NotificationContext = React.createContext({
  openNotification: () => {}
});

export const NotificationProvider = ({ children }) => {
  const [api, contextHolder] = notification.useNotification({
    bottom: 50,
    placement: 'top',
    maxCount: 1
  });

  const openNotification = ({ duration = 1500, ...props }) => {
    api.open({
      ...props,
      duration,
      message: '',
      className: 'vsc-notification',
      icon: <img src={alertIcons.alertInfo} alt="" />
    });

    setTimeout(() => {
      api.destroy();
    }, duration);
  };

  return (
    <NotificationContext.Provider value={{ openNotification }}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => React.useContext(NotificationContext);
